
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';

@Component({
  selector: 'app-receipt-confirmation-grid',
  templateUrl: './receipt-confirmation-grid.component.html',
  styleUrls: ['./receipt-confirmation-grid.component.css']
})
export class ReceiptConfirmationGridComponent implements OnInit {

  title="Receipt Confirmation";
  dtOptions: any = {};
  empList :any =[];
  mode :any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;


  constructor(public service : UserService) { }

  ngOnInit(): void {
    this.empList = this.service.empList;
    //
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component.ts